import { Component, OnInit, Input } from '@angular/core';
import { NormalizedPlanBaseModel } from '@frontend/unhideschool/modules/membership/models/membership-normalized-plan.model';
import { UNHMembershipPrincingTranslation } from '@frontend/unhideschool/app/utils/i18n/locale/unh-membership-pricing/unh-membership-pricing.i18n.model';
import { UseTranslations } from '@frontend/unhideschool/app/utils/i18n/use-translation.decorator';


interface Translations {
  "unh-membership-pricing": UNHMembershipPrincingTranslation;
}

interface PriceBoxCommunityTranslation {
  title:string;
  subtitle:string;
  free: boolean;
  priceFull: number;
  price: number;
  period: string;
  artists: number;
  description: string;

}
@Component({
  selector: 'unh-price-box-bordless',
  templateUrl: './price-box-bordless.component.html',
  styleUrls: ['./price-box-bordless.component.scss']
})

@UseTranslations({
  translatableComponents : ["unh-membership-pricing"]
})


export class PriceBoxBordlessComponent implements OnInit {
  @Input() plan: any; // NormalizedPlanBaseModel; // ???

  priceBoxTranslation : PriceBoxCommunityTranslation;
  membershipPricingMock : UNHMembershipPrincingTranslation;

  translations: Promise<Translations>;

  ngOnInit(): void {
    this.translations.then((translations) => {
      this.membershipPricingMock = translations['unh-membership-pricing'];
    })
  }

}






